import { api } from '@/lib/api-manager'
import type { Request } from '@/types/requests/request'

export async function getRequestById(id: string) {
  const response = await api.get(`v1/requests/request/${id}`)
  const data: Request = response.data.data
  return data
}
